const data = {
  interviews: [
    {
      title: 'If Your Brand Was a Summer Camp, What Would It Be?',
      source: 'The Pollinatr',
      url: 'https://thepollinatr.substack.com/p/if-your-brand-was-a-summer-camp-what',
      date: 'July 31, 2026',
    },
    {
      title: 'How Camps Can Build a Referral System That Actually Works',
      source: 'Grow Your Camp Podcast',
      url: 'https://open.spotify.com/episode/4B8B916PBt5VOdtJoAPemR?si=0a05bdaec7c84b26',
      date: 'July 3, 2026',
    },
    {
      title: 'Modern "Operations" at Your Camp',
      source: 'CampHacker Podcast',
      url: 'https://open.spotify.com/episode/3nUwbtf7tBt7ej1KVVrJCy?si=859d6c42de184266',
      date: 'May 29, 2025',
    },
    {
      title: 'How to Go From Bootcamp Grad to Senior Engineer',
      source: 'Develop Yourself Podcast',
      url: 'https://open.spotify.com/episode/5e9MlP1JhFw492rIMYUpNF?si=1f78955d5bb74341',
      date: 'November 20, 2021',
    },
    {
      title: 'How Peter Elbaum tripled his salary by learning to code',
      source: 'No CS Degree',
      url: 'https://www.nocsdegree.com/how-this-person-tripled-their-salary-by-learning-to-code/',
      date: 'March 26, 2020',
    }
  ]
}

export default data 